"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStripeEnabledContext = exports.useStripeContext = exports.buildEndpointError = exports.StripeDisabledContextProvider = exports.StripeEnabledContextProvider = void 0;
var stripe_js_1 = require("@stripe/stripe-js");
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var StripeContext = react_1.default.createContext(undefined);
var StripeEnabledContextProvider = function (_a) {
    var children = _a.children, stripePublicKey = _a.stripePublicKey, stripeUserId = _a.stripeUserId;
    var _b = __read((0, react_1.useState)(), 2), stripe = _b[0], setStripe = _b[1];
    var cardElementRef = (0, react_1.useRef)();
    var elementsRef = (0, react_1.useRef)();
    var createCard = function (externalFields) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!stripe) {
                        throw new Error("Stripe not initialised");
                    }
                    if (!cardElementRef.current) {
                        throw new Error("Stripe Card Element is not set");
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, stripe.createPaymentMethod({
                            type: "card",
                            card: cardElementRef.current,
                            billing_details: {
                                name: externalFields.name,
                                email: externalFields.email,
                                address: {
                                    postal_code: externalFields.zip,
                                },
                            },
                        })];
                case 2:
                    result = _a.sent();
                    if (result.error != null) {
                        throw result.error;
                    }
                    return [2, parsePaymentMethod(result.paymentMethod)];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    throw error_1;
                case 4: return [2];
            }
        });
    }); };
    var addPayment = function (paymentUrl, payload) { return __awaiter(void 0, void 0, void 0, function () {
        var handlePaymentAttempt, responseData, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!payload.payment) {
                        throw new Error("Cannot attempt a payment without payment details in the payload");
                    }
                    handlePaymentAttempt = function (response) { return __awaiter(void 0, void 0, Promise, function () {
                        var handledCardAction, confirmResponse, error_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if ("error" in response && response.error) {
                                        throw response.error;
                                    }
                                    if (!("requiresAction" in response && response.requiresAction)) return [3, 6];
                                    if (!stripe) {
                                        throw new Error("Stripe not initialised");
                                    }
                                    return [4, stripe.handleCardAction(response.paymentIntentClientSecret)];
                                case 1:
                                    handledCardAction = _a.sent();
                                    if (handledCardAction.error) {
                                        throw handledCardAction.error;
                                    }
                                    if (payload.payment) {
                                        delete payload.payment.paymentMethodId;
                                        payload.payment.paymentIntentId = handledCardAction.paymentIntent.id;
                                    }
                                    confirmResponse = void 0;
                                    _a.label = 2;
                                case 2:
                                    _a.trys.push([2, 4, , 5]);
                                    return [4, axios_1.default.post(paymentUrl, payload, { withCredentials: true })];
                                case 3:
                                    confirmResponse = _a.sent();
                                    return [3, 5];
                                case 4:
                                    error_3 = _a.sent();
                                    throw (0, exports.buildEndpointError)(error_3);
                                case 5:
                                    if (confirmResponse) {
                                        return [2, handlePaymentAttempt(confirmResponse.data)];
                                    }
                                    _a.label = 6;
                                case 6: return [2];
                            }
                        });
                    }); };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.post(paymentUrl, payload, { withCredentials: true })];
                case 2:
                    response = _a.sent();
                    (responseData = response.data);
                    return [3, 4];
                case 3:
                    error_2 = _a.sent();
                    throw (0, exports.buildEndpointError)(error_2);
                case 4:
                    if (responseData) {
                        return [2, handlePaymentAttempt(responseData)];
                    }
                    return [2];
            }
        });
    }); };
    var addPaymentV2 = function (createSetupIntentUrl, addPaymentUrl, payload, billingDetails) { return __awaiter(void 0, void 0, void 0, function () {
        var stripe, elements, submitError, clientSecret, createSetupIntentResponse, error_4, _a, error, setupIntent, error_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, stripePromise];
                case 1:
                    stripe = _b.sent();
                    elements = elementsRef.current;
                    if (!elements) {
                        throw new Error("No active payment to confirm.");
                    }
                    return [4, elements.submit()];
                case 2:
                    submitError = (_b.sent()).error;
                    if (submitError) {
                        throw new Error("stripe validation error");
                    }
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 5, , 6]);
                    return [4, axios_1.default.post(createSetupIntentUrl, payload, {
                            withCredentials: true,
                        })];
                case 4:
                    createSetupIntentResponse = _b.sent();
                    clientSecret = createSetupIntentResponse.data.clientSecret;
                    return [3, 6];
                case 5:
                    error_4 = _b.sent();
                    throw (0, exports.buildEndpointError)(error_4);
                case 6: return [4, stripe.confirmSetup({
                        elements: elements,
                        clientSecret: clientSecret,
                        confirmParams: {
                            payment_method_data: {
                                billing_details: billingDetails,
                            },
                            return_url: window.location.href,
                        },
                        redirect: "if_required",
                    })];
                case 7:
                    _a = _b.sent(), error = _a.error, setupIntent = _a.setupIntent;
                    if (error) {
                        console.error(error);
                        throw new Error("Couldn't confirm payment details. (error: ".concat(error.code, ")"));
                    }
                    _b.label = 8;
                case 8:
                    _b.trys.push([8, 10, , 11]);
                    return [4, axios_1.default.post(addPaymentUrl, __assign(__assign({}, payload), { setupIntentId: setupIntent.id }), { withCredentials: true })];
                case 9:
                    _b.sent();
                    return [3, 11];
                case 10:
                    error_5 = _b.sent();
                    throw (0, exports.buildEndpointError)(error_5);
                case 11: return [2];
            }
        });
    }); };
    var checkPayment = function (url) { return __awaiter(void 0, void 0, void 0, function () {
        var responseData, response, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.get(url, { withCredentials: true })];
                case 1:
                    response = _a.sent();
                    (responseData = response.data);
                    return [3, 3];
                case 2:
                    error_6 = _a.sent();
                    throw (0, exports.buildEndpointError)(error_6);
                case 3: return [2, responseData];
            }
        });
    }); };
    var stripePromise = (0, react_1.useMemo)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var stripe;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, (0, stripe_js_1.loadStripe)(stripePublicKey, {
                        stripeAccount: stripeUserId,
                        apiVersion: "2024-09-30.acacia",
                    })];
                case 1:
                    stripe = _a.sent();
                    if (!stripe) {
                        throw new Error("Stripe failed to load");
                    }
                    setStripe(stripe);
                    return [2, stripe];
            }
        });
    }); }, [stripePublicKey, stripeUserId]);
    return (react_1.default.createElement(StripeContext.Provider, { value: {
            cardElementRef: cardElementRef,
            stripe: stripe,
            createCard: createCard,
            addPayment: addPayment,
            stripePromise: stripePromise,
            elementsRef: elementsRef,
            addPaymentV2: addPaymentV2,
            checkPayment: checkPayment,
            enabled: true,
        } }, children));
};
exports.StripeEnabledContextProvider = StripeEnabledContextProvider;
var StripeDisabledContextProvider = function (_a) {
    var children = _a.children;
    return react_1.default.createElement(StripeContext.Provider, { value: { enabled: false } }, children);
};
exports.StripeDisabledContextProvider = StripeDisabledContextProvider;
var parsePaymentMethod = function (paymentMethod) {
    var cardObject = paymentMethod.card;
    var billingDetails = paymentMethod.billing_details;
    return {
        paymentMethodId: paymentMethod.id,
        name: billingDetails.name,
        email: billingDetails.email,
        last4: cardObject.last4,
        brand: cardObject.brand,
        expiryMonth: cardObject.exp_month,
        expiryYear: cardObject.exp_year,
    };
};
var buildEndpointError = function (error) {
    var _a;
    if (axios_1.default.isAxiosError(error)) {
        var responseData = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
        if (responseData === null || responseData === void 0 ? void 0 : responseData.message) {
            return new Error(responseData.message);
        }
    }
    return new Error("It looks like there was a network error. Please check your connection and try again.");
};
exports.buildEndpointError = buildEndpointError;
var useStripeContext = function () {
    var stripeContext = react_1.default.useContext(StripeContext);
    if (!stripeContext) {
        throw new Error("useStripeContext can only be used inside a StripeContextProvider");
    }
    return stripeContext;
};
exports.useStripeContext = useStripeContext;
var useStripeEnabledContext = function () {
    var stripeContext = (0, exports.useStripeContext)();
    if (!stripeContext.enabled) {
        throw new Error("useStripeEnabledContext can only be used in a context where Stripe is enabled");
    }
    return stripeContext;
};
exports.useStripeEnabledContext = useStripeEnabledContext;
